<template>
  <div class="step-actions-editor">
    <div class="toolbar">
      <el-button type="primary" size="small" @click="addAction">添加动作</el-button>
    </div>
    <el-table :data="actions" border style="margin-top: 10px">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="动作类型" prop="actionType" width="150">
        <template slot-scope="scope">
          <el-select
            :value="scope.row.actionType"
            @change="updateAction(scope.$index, 'actionType', $event)"
            placeholder="请选择动作类型"
          >
            <el-option
              v-for="option in actionTypeOptions"
              :key="option.value"
              :label="option.label || option.value"
              :value="option.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="动作名称" prop="actionName">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.actionName"
            @input="updateAction(scope.$index, 'actionName', $event)"
            placeholder="请输入动作名称"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="条件表达式" prop="condition" width="200">
        <template slot-scope="scope">
          <span
            v-if="scope.row.condition"
            :title="scope.row.condition"
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block"
          >
            {{ scope.row.condition }}
          </span>
          <span v-else style="color: #c0c4cc">未设置</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editAction(scope.$index)">编辑详情</el-button>
          <el-button type="text" size="small" @click="removeAction(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 动作详情编辑对话框 -->
    <el-dialog
      :visible.sync="actionDialogVisible"
      :title="actionDialogTitle"
      width="600px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :model="currentAction" :size="size" label-width="120px" v-if="currentAction">
        <el-form-item label="动作类型">
          <el-select
            :value="currentAction.actionType"
            @change="updateCurrentAction('actionType', $event)"
            placeholder="请选择动作类型"
          >
            <el-option
              v-for="option in actionTypeOptions"
              :key="option.value"
              :label="option.label || option.value"
              :value="option.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="动作名称">
          <el-input
            :value="currentAction.actionName"
            @input="updateCurrentAction('actionName', $event)"
            placeholder="请输入动作名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="条件表达式">
          <el-input
            :value="currentAction.condition"
            @input="updateCurrentAction('condition', $event)"
            type="textarea"
            :rows="2"
            placeholder="请输入EL条件表达式，如: ${cacheOrder.status} == 'PAID'"
          ></el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 4px">
            可选，留空表示无条件执行
          </div>
        </el-form-item>

        <!-- METHOD_CALL 类型 -->
        <template v-if="currentAction.actionType === 'METHOD_CALL'">
          <!-- <el-form-item label="Bean名称">
            <el-input
              :value="currentAction.methodCall.beanName"
              @input="updateMethodCall('beanName', $event)"
              placeholder="请输入Bean名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="方法名称">
            <el-input
              :value="currentAction.methodCall.methodName"
              @input="updateMethodCall('methodName', $event)"
              placeholder="请输入方法名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="结果变量">
            <el-input
              :value="currentAction.methodCall.resultVariable"
              @input="updateMethodCall('resultVariable', $event)"
              placeholder="请输入结果变量名"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数">
            <div
              v-for="(arg, index) in currentAction.methodCall.args"
              :key="index"
              style="margin-bottom: 10px"
            >
              <el-input
                :value="arg"
                @input="updateArg(index, $event)"
                placeholder="请输入参数，可使用变量如 #cacheOrder.id"
              >
                <el-button
                  slot="append"
                  icon="el-icon-delete"
                  @click="removeArg(index)"
                ></el-button>
              </el-input>
            </div>
            <el-button type="text" size="small" @click="addArg">添加参数</el-button>
          </el-form-item>
        </template>

        <!-- SET_VARIABLE 类型 -->
        <template v-if="currentAction.actionType === 'SET_VARIABLE'">
          <el-form-item label="变量名">
            <el-input
              :value="currentAction.variableSet.variableName"
              @input="updateVariableSet('variableName', $event)"
              placeholder="请输入变量名"
            ></el-input>
          </el-form-item>
          <el-form-item label="变量值">
            <el-input
              :value="currentAction.variableSet.value"
              @input="updateVariableSet('value', $event)"
              placeholder="请输入变量值"
            ></el-input>
          </el-form-item>
          <el-form-item label="变量值表达式">
            <el-input
              :value="currentAction.variableSet.expression"
              @input="updateVariableSet('expression', $event)"
              placeholder="请输入变量值表达式，如: #cacheOrder.id"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer">
        <el-button type="primary" :size="size" @click="saveAction">保存</el-button>
        <el-button type="info" :size="size" @click="actionDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "StepActionsEditor",
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      actionDialogVisible: false,
      currentActionIndex: -1,
      currentAction: null
    };
  },
  inject: {
    getEditingStepData: {
      from: "getEditingStepData",
      default: () => () => null
    },
    updateEditingStepActions: {
      from: "updateEditingStepActions",
      default: () => () => {}
    }
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    }),
    ...mapGetters("problemFlowConfig", ["steps", "actionTypeOptions"]),
    actions() {
      // 优先使用临时编辑状态，否则使用 store 中的数据
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        return editingStepData.actions || [];
      }
      const step = this.steps[this.stepId];
      return step?.actions || [];
    },
    actionDialogTitle() {
      return this.currentActionIndex >= 0 ? "编辑动作" : "新增动作";
    }
  },
  methods: {
    updateActions(newActions) {
      // 优先更新临时编辑状态，否则直接更新 store
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        this.updateEditingStepActions("actions", newActions);
      } else {
        this.$store.dispatch("problemFlowConfig/updateStepField", {
          stepId: this.stepId,
          field: "actions",
          value: newActions
        });
      }
    },
    updateAction(index, field, value) {
      // 更新单个动作的字段
      const actions = [...this.actions];
      actions[index] = { ...actions[index], [field]: value };
      this.updateActions(actions);
    },
    addAction() {
      this.currentActionIndex = -1;
      this.currentAction = {
        actionType: "METHOD_CALL",
        actionName: "",
        condition: "",
        methodCall: {
          beanName: "",
          methodName: "",
          resultVariable: "",
          args: []
        },
        variableSet: {
          variableName: "",
          value: ""
        }
      };
      this.actionDialogVisible = true;
    },
    editAction(index) {
      this.currentActionIndex = index;
      this.currentAction = JSON.parse(JSON.stringify(this.actions[index]));
      // 确保 condition 字段存在
      if (this.currentAction.condition === undefined) {
        this.currentAction.condition = "";
      }
      if (!this.currentAction.methodCall) {
        this.currentAction.methodCall = {
          beanName: "",
          methodName: "",
          resultVariable: "",
          args: []
        };
      }
      if (!this.currentAction.variableSet) {
        this.currentAction.variableSet = {
          variableName: "",
          value: ""
        };
      }
      this.actionDialogVisible = true;
    },
    removeAction(index) {
      const actions = [...this.actions];
      actions.splice(index, 1);
      this.updateActions(actions);
    },
    saveAction() {
      const actions = [...this.actions];
      if (this.currentActionIndex >= 0) {
        actions[this.currentActionIndex] = { ...this.currentAction };
      } else {
        actions.push({ ...this.currentAction });
      }
      this.updateActions(actions);
      this.actionDialogVisible = false;
    },
    updateCurrentAction(field, value) {
      this.currentAction = { ...this.currentAction, [field]: value };
    },
    updateMethodCall(field, value) {
      this.currentAction = {
        ...this.currentAction,
        methodCall: {
          ...this.currentAction.methodCall,
          [field]: value
        }
      };
    },
    updateVariableSet(field, value) {
      this.currentAction = {
        ...this.currentAction,
        variableSet: {
          ...this.currentAction.variableSet,
          [field]: value
        }
      };
    },
    addArg() {
      if (!this.currentAction.methodCall.args) {
        this.currentAction.methodCall.args = [];
      }
      const args = [...this.currentAction.methodCall.args];
      args.push("");
      this.currentAction = {
        ...this.currentAction,
        methodCall: {
          ...this.currentAction.methodCall,
          args
        }
      };
    },
    removeArg(index) {
      const args = [...this.currentAction.methodCall.args];
      args.splice(index, 1);
      this.currentAction = {
        ...this.currentAction,
        methodCall: {
          ...this.currentAction.methodCall,
          args
        }
      };
    },
    updateArg(index, value) {
      const args = [...this.currentAction.methodCall.args];
      args[index] = value;
      this.currentAction = {
        ...this.currentAction,
        methodCall: {
          ...this.currentAction.methodCall,
          args
        }
      };
    }
  }
};
</script>

<style lang="less" scoped>
.step-actions-editor {
  padding: 10px;
}
</style>
